import React from 'react';
export function VslHeader() {
  return <header className="fixed top-0 left-0 right-0 z-50 flex items-center justify-center py-2 bg-black/50 backdrop-blur-md border-b border-white/10" data-id="element-451">
      <div className="w-6 h-6 md:w-8 md:h-8" data-id="element-452">
        <img src="https://cdn.magicpatterns.com/uploads/gAEFsAJYA7FcAnLZKBQtQf/ChatGPT_Image_Dec_16,_2025,_03_06_54_PM.png" alt="HeyLloyd Logo" className="w-full h-full object-contain" data-id="element-453" />
      </div>
    </header>;
}